import React from 'react';
const day = value => value ? new Date(value).toLocaleDateString('en-GB') : '—';

export function PlatformPaymentForm({ data }) {
  return <section className="border rounded p-4 space-y-2">
    <h4 className="font-semibold">Psychologist Platform Payment History</h4>
    <p className="text-sm">The current platform offer is complimentary. Payment collection is unavailable.</p>
    {!data.payments?.length && <p>No platform payments recorded.</p>}
    <ol className="space-y-2 text-xs">{[...(data.payments || [])].reverse().map(p => <li className="border-b pb-2" key={p.id}>{p.plan.name} · {p.currency} {p.amount} · {p.status}<br />{day(p.period_start)} → {day(p.period_end)} · {p.payment_method} · {p.reference}<br />Payment {day(p.payment_date)} · Recorded {new Date(p.timestamp).toLocaleString()} · Admin {p.admin_id}<br />{p.note}</li>)}</ol>
  </section>;
}

export function PlatformPlans() {
  return <section className="border rounded p-5 space-y-2"><h3 className="font-semibold">INSIGHT Complimentary Free Plan</h3><p>1 Year (12 calendar months) for newly activated access. Existing entitlements are preserved.</p><p>Paid plans are unavailable. A future paid model requires separate approval and implementation.</p></section>;
}
